import { ApolloClient, InMemoryCache, gql } from '@apollo/client';
import axiosWithAuthInterceptor from '../util/axiosWithAuthInterceptor';
import { apolloClient as client } from "../data-provider/graphqlDataProvider";

let token: any = localStorage.getItem('credentials')
// const client = new ApolloClient({
//     uri: `${process.env.REACT_APP_DATAPROVIDER}`,
//     headers: { authorization: token },
//     cache: new InMemoryCache({
//         addTypename: false,
//         resultCaching: false
//     }),
//     defaultOptions: {
//         watchQuery: {
//             fetchPolicy: 'no-cache',
//             errorPolicy: 'ignore',
//         },
//         query: {
//             fetchPolicy: 'no-cache',
//             errorPolicy: 'all',
//         },
//     }
// });

export function getPartnerDiscountSmsLogList(params: any){    
    const GET_SMS_LOG = gql`
    query getSmsLog($where: PartnerDiscountSmsLogWhereInput, $orderBy: [PartnerDiscountSmsLogOrderByWithRelationInput!], $take: Int, $skip: Int){
        partnerDiscountSmsLogs(where: $where, orderBy: $orderBy, take: $take, skip: $skip){
          id
          mobile
          createdAt
          createdBy
          message
          orderId
          partnerDiscountUsageId
          smsId
          status
          updatedAt
          updatedBy
        }  
      }
    `;
    let filterData = deleteNullPropertyValueDiscountFilter(params.filter) 
    return client.query({
        query: GET_SMS_LOG,
        variables: {
            skip: params.pagination.perPage * (params.pagination.page - 1),
            take: params.pagination.perPage,
            where: { ...filterData },
            orderBy: {updatedAt: "Desc"}
        }
    })
}

export async function getPartnerDiscountSmsLogCount(params: any) {  
    const GET_SMS_LOG_COUNT = gql`
    {
        aggregatePartnerDiscountSmsLog(where:{mobile: {contains: "${params.filter.mobile.contains}"}}){
          _count{
            id
          }
      
        }
      }
    `;
    return client.query({
        query: GET_SMS_LOG_COUNT
    }).then(res => {        
        return res.data.aggregatePartnerDiscountSmsLog._count.id
    })
}

export async function resendSms(partnerDiscountUsageId: string){
    console.log('partnerDiscountUsageId: ', partnerDiscountUsageId);
    return axiosWithAuthInterceptor({
        url: `${process.env.REACT_APP_LEMONADE_SERVER}/api/partner-discounts/sms-logs/resend`,
        method: 'POST',
        data: {partnerDiscountUsageId: partnerDiscountUsageId},
    })
}

export const deleteNullPropertyValueDiscountFilter = (filter: any) => {
    let filterData = { ...filter }
    if (!filterData.mobile.contains)
        delete filterData.mobile
    return filterData
}